import { Component } from '@angular/core';

@Component({
  selector: 'app-standby-list-info',
  templateUrl: './standby-list-info.component.html',
  styleUrls: ['./standby-list-info.component.scss'],
})
export class StandbyListInfoComponent {}
